import { Box, Typography } from "@mui/material";
import { CommonStyle, ControlledTable, Loader } from "Components";
import CstmBtn from "Components/CstmBtn";
import { RouteUrls } from "Constant/RouteUrls";
import { FC, useEffect, useState } from "react";
import CommonFormatter from "Utils/Common.Formatter";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  PreApprovedOptionType,
  PreApprovedPlanType,
} from "DataTypes/PatientManagement.type";
import PreApprovedPlanApi from "Service/PreApprovedPlan.api";
import PreApprovedPlanFormatter from "Utils/PreApprovedPlan.Formatter";
import { TableLayout } from "Layouts";
import { IcdCodeType } from "DataTypes/Services/Problem.type";
import ProblemApi from "Service/Problem.api";
import ProbFormatter from "Utils/Prob.Formatter";
import { ICDTableCol } from "./Data";
import NoData from "Components/NoData";
import { HeaderInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import ReusablePAPUI from "Components/ReusablePAPUI";

const PlanDetails: FC = () => {
  const { planId, orgId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const [planData, setPlanData] = useState<PreApprovedPlanType | null>(null);
  const [codeList, setCodeList] = useState<IcdCodeType[]>([]);
  const [planLoading, setPlanLoading] = useState(true);
  const [icdLoading, setICDLoading] = useState(true);
  const isPlanEditable = false;

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "pre-approved-plan-details",
      label: "Plan Details",
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${orgId || organization.id}/${RouteUrls.preApprovedPlan}` +
        `/${RouteUrls.list}`,
      level: 3,
      link: RouteUrls.plan,
      navType: "org",
    });
    PlanSearch();
  }, []);

  useEffect(() => {
    if (planData?.problemId) getCodeList();
  }, [planData?.problemId]);

  const PlanSearch: () => void = async () => {
    const res = await PreApprovedPlanApi.PlanSearch({
      id1: planId,
      data: { planVersionId: state?.planVersionId }
    });
    if (res?.success) {
      const formattedData = PreApprovedPlanFormatter.PlanSearch(res?.data);
      setPlanData(formattedData);
    }
    setPlanLoading(false);
  };

  const handleAddUpdateOption: (
    data: PreApprovedOptionType,
    catType: string
  ) => Promise<boolean> = async () => false;

  const handleDeleteOption: (
    deleteOptId: number | null,
    catType: string
  ) => void = () => undefined;

  const getCodeList: () => void = async () => {
    const res = await ProblemApi.icdCodeList({
      id1: planData?.problemId,
    });
    if (res?.success) setCodeList(ProbFormatter.IcdCodes(res?.data));
    setICDLoading(false);
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => ICDTableCol}
      tableRow={codeList}
      cellType="border"
    />
  );

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      {planLoading ? <Loader /> : planData ?
        <Box sx={{ p: 2 }}>
          <Typography mb={1} variant="body2">
            <b>Plan For :</b> {planData?.problemName}
          </Typography>
          <Typography mb={2} variant="body2">
            <b>Plan Status :</b> {planData?.approvalStatus}
          </Typography>
          <Box display="flex">
            <Box width={"50%"}>
              <ReusablePAPUI
                handleAddUpdateOption={handleAddUpdateOption}
                handleDeleteOption={handleDeleteOption}
                isPlanEditable={isPlanEditable}
                planData={planData}
              />
              <Box
                display="flex"
                justifyContent="flex-end"
                sx={{ ">button": { mr: 1 } }}
              >
                <CstmBtn
                  label="Back"
                  btnType="border"
                  onClick={() => navigate(-1)}
                  sxProps={{ mt: 1, p: 1 }}
                />
              </Box>
            </Box>
            <Box width="50%" ml={5}>
              <TableLayout
                tblBody={TblBodyJSX}
                tblHead={ControlledTable.TblHead(ICDTableCol)}
                height={"93%"}
                loading={icdLoading}
                pageRecordCount={codeList.length}
              />
            </Box>
          </Box>
        </Box>
        :
        <NoData />}
    </Box>
  );
};

export default PlanDetails;
